import React, { useCallback, useEffect, useState } from "react";
import { Check, RefreshCw, ThumbsUp, UserPen } from "lucide-react";
import { practiceApi } from "../../lib/practiceApi";

export const NamingPanel = ({ embedded = false }) => {
  const [items, setItems] = useState([]);
  const [drafts, setDrafts] = useState({});
  const [busy, setBusy] = useState("");
  const [error, setError] = useState("");
  const [flash, setFlash] = useState("");

  const load = useCallback(async () => {
    setError("");
    try {
      const res = await practiceApi("/naming/review");
      setItems(res.items || []);
      setDrafts(Object.fromEntries((res.items || []).map(i => [`${i.kind}-${i.id}`, { last_name: i.last_name, first_name: i.first_name }])));
    } catch (err) { setError(err.message); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const key = item => `${item.kind}-${item.id}`;
  const set = (item, field, value) => setDrafts(d => ({ ...d, [key(item)]: { ...d[key(item)], [field]: value } }));

  async function apply(item) {
    setBusy(key(item)); setError("");
    try {
      const draft = drafts[key(item)] || {};
      await practiceApi("/naming/apply", { method: "POST", body: JSON.stringify({ kind: item.kind, id: item.id, ...draft }) });
      setItems(rows => rows.filter(r => key(r) !== key(item)));
      setFlash(`Aggiornato: ${[draft.last_name, draft.first_name].filter(Boolean).join(" ")}`);
      setTimeout(() => setFlash(""), 5000);
    } catch (err) { setError(err.message); } finally { setBusy(""); }
  }

  async function keep(item) {
    setBusy(key(item)); setError("");
    try {
      await practiceApi("/naming/keep", { method: "POST", body: JSON.stringify({ kind: item.kind, id: item.id }) });
      setItems(rows => rows.filter(r => key(r) !== key(item)));
    } catch (err) { setError(err.message); } finally { setBusy(""); }
  }

  return <div data-testid="naming-panel">
    {!embedded && <div className="practice-notice" data-testid="naming-note"><span>Tutte le persone si scrivono <b>prima il cognome, poi il nome</b>: così ordinamenti e filtri partono sempre dal cognome. Qui trovi i dati già inseriti con la divisione proposta: confermala, correggila o lascia il record così com'è.</span></div>}
    <div className="settings-team-head">
      <span data-testid="naming-count">{items.length ? `${items.length} anagrafiche da confermare` : "Tutte le anagrafiche sono conformi"}</span>
      <button className="icon-btn" title="Ricarica" data-testid="naming-refresh" onClick={load}><RefreshCw size={14} /></button>
    </div>
    {flash && <div className="flash" data-testid="naming-flash">{flash}</div>}
    {error && <div className="error" role="alert" data-testid="naming-error">{error}</div>}
    <div className="data-table">
      <div className="table-head" style={{ gridTemplateColumns: "1fr 1.3fr 1fr 1fr 190px" }}>
        <span>tipo</span><span>come è scritto ora</span><span>cognome</span><span>nome</span><span>azioni</span>
      </div>
      {items.map((item, index) => <div className="table-row" key={key(item)} data-testid={`naming-row-${index}`} style={{ gridTemplateColumns: "1fr 1.3fr 1fr 1fr 190px" }}>
        <span><strong>{item.label}</strong>{item.context ? <small className="receivables-practices">{item.context}</small> : null}{item.looks_company ? <small className="receivables-practices">sembra una società o un'intestazione collettiva</small> : null}</span>
        <span>{item.current || "—"}</span>
        <span><input data-testid={`naming-last-${index}`} value={drafts[key(item)]?.last_name || ""} onChange={e => set(item, "last_name", e.target.value)} /></span>
        <span><input data-testid={`naming-first-${index}`} value={drafts[key(item)]?.first_name || ""} onChange={e => set(item, "first_name", e.target.value)} /></span>
        <span style={{ display: "flex", gap: 6 }}>
          <button className="primary sollecito" disabled={busy === key(item)} data-testid={`naming-apply-${index}`} onClick={() => apply(item)}><Check size={13} />Conferma</button>
          <button className="icon-btn" title="Va bene così com'è" disabled={busy === key(item)} data-testid={`naming-keep-${index}`} onClick={() => keep(item)}><ThumbsUp size={14} /></button>
        </span>
      </div>)}
      {!items.length && <div className="empty"><UserPen size={26} /><strong>Nomenclatura a posto</strong><span>Committenti, collaboratori e referenti sono scritti come Cognome Nome.</span></div>}
    </div>
  </div>;
};
